import React, { useEffect } from "react";

import { Dialog, DialogContent, DialogHeader } from "../ui/dialog.tsx";

import { IntegrationHeader } from "./Integrations/IntegrationHeader.tsx";

import { IntegrationContent } from "./Integrations/IntegrationBody.tsx";

type IntegrationsModalProps = {
    isOpen: boolean;
    onClose: (open: boolean) => void;
    integrationType: string;
    setIntegrationType: (type: string) => void;
    setIntegrationDialog: (open: boolean) => void;
};

const IntegrationsModal = ({
    isOpen,
    integrationType,
    setIntegrationType,
    setIntegrationDialog,
}: IntegrationsModalProps) => {
    //if url contains /googlesheet?verify=true then open the dialog
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const verify = urlParams.get("googlesheet");
        if (verify === "true") {
            setIntegrationType("googleSheet");
            setIntegrationDialog(true);
            // remove the ?googlesheet?=true from the url
            const newUrl = window.location.href.split("?")[0];
            window.history.replaceState({}, document.title, newUrl);
        }
    }, []);
    return (
        <Dialog open={isOpen} onOpenChange={() => setIntegrationDialog(false)}>
            <DialogContent className="sm:w-[840px] max-w-[840px] max-h-[600px] w-full p-0 gap-0 top-[50%]">
                <DialogHeader className="p-3 border-b border-b-[#F1F2F4] h-[61px] ">
                    <IntegrationHeader integrationType={integrationType} />
                </DialogHeader>
                <div className="flex flex-col items-center h-full">
                    <div className="flex w-full h-[539px]">
                        <IntegrationContent
                            setIntegrationDialog={setIntegrationDialog}
                            integrationType={integrationType}
                        />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default IntegrationsModal;
